export const GOOGLE_MAPS_API_KEY = 'AIzaSyBXln3-vP88FrR3zwzpue9z9oQ4A7xWx9A';
